import { render, staticRenderFns } from "./PatientPanel.vue?vue&type=template&id=73903d44&scoped=true"
import script from "./PatientPanel.vue?vue&type=script&lang=js"
export * from "./PatientPanel.vue?vue&type=script&lang=js"
import style0 from "./PatientPanel.vue?vue&type=style&index=0&id=73903d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73903d44",
  null
  
)

export default component.exports